import React from 'react';
import { TutorialModal } from '../../modal/tutorial-modal';
import { Modal } from '../../modal';

import PropTypes from 'prop-types';

const TutorialModalParent = props => {
    const { screen, onClick } = props;

    return (
        <Modal ariaLabel={`${screen} tutorial`} onClick={onClick}>
            <TutorialModal screen={screen} />
        </Modal>
    );
};

TutorialModalParent.propTypes = {
    screen: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export { TutorialModalParent };
